import config from './../config';

let accountingApiBaseUrl = config.get('ACCOUNTING_API_URL');
let reconciliationApiBaseUrl = config.get('RECONCILIATION_API_URL');

const AccountingApiRoutes = {
  GET_QBO_CONFIG_URL: accountingApiBaseUrl + '/qbo-config-url',
};

const ReconciliationApiRoutes = {
  GET_CLIENT_SETTINGS_URL: reconciliationApiBaseUrl + '/client-settings',
  GET_RECONCILIATION_MEMBER_SETTINGS_URL: reconciliationApiBaseUrl + '/member-settings'
};

const requestTypes = {
  GET: 'get',
  PATCH: 'patch'
};

export { AccountingApiRoutes, requestTypes, ReconciliationApiRoutes };